import React from 'react';

import mailTokens from '@amzn/meridian-tokens/base/icon/mail';
import phoneTokens from '@amzn/meridian-tokens/base/icon/phone';
import starTokens from '@amzn/meridian-tokens/base/icon/star-filled';
import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Link from '@amzn/meridian/link';
import Row from '@amzn/meridian/row';
import Tag from '@amzn/meridian/tag';
import Text from '@amzn/meridian/text';

import { IVendorContact } from 'src/data/VendorContactsData';

interface ContactCardProps {
    contact: IVendorContact;
}

export const ContactCard: React.FC<ContactCardProps> = ({ contact }) => {
    return (
        <Card spacingInset="400">
            <Column spacing="200">
                <Row alignmentHorizontal="justify" alignmentVertical="center">
                    <Row spacing="400" alignmentVertical="center">
                        <Text type="h100">{contact.name}</Text>
                        {contact.isPrimary && <Icon className="primary-star" tokens={starTokens} />}
                    </Row>
                    <Tag>{contact.function}</Tag>
                </Row>
                <Text type="b300">{contact.role}</Text>
                <Text type="b300">{contact.location}</Text>
                <Link href={`mailto:${contact.email}`}>
                    <Row spacing="200">
                        <Icon tokens={mailTokens} />
                        <Text type="b300">{contact.email}</Text>
                    </Row>
                </Link>
                <Link href={`tel:${contact.phone}`}>
                    <Row spacing="200">
                        <Icon tokens={phoneTokens} />
                        <Text type="b300">{contact.phone}</Text>
                    </Row>
                </Link>
            </Column>
        </Card>
    );
};
